import { render, staticRenderFns } from "./RowEditJournalName.vue?vue&type=template&id=46f63354&"
import script from "./RowEditJournalName.vue?vue&type=script&lang=js&"
export * from "./RowEditJournalName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports